// SheetSwitcher.js
import React, { useMemo } from 'react';
import { Group, Select, Badge, Tooltip, Text } from '@mantine/core';

export default function SheetSwitcher({
  sheets = [], // [{sheetId, index, name, rows, cols}]
  activeSheetId = '0', // string
  onChange, // (sheetIdStr) => void
  compact = false,
}) {
  const data = useMemo(
    () =>
      sheets.map((s) => ({
        value: String(s.sheetId ?? s.index),
        label: s.name || `Sheet ${s.index}`,
        description: `${s.rows ?? '—'} rows · ${s.cols ?? '—'} cols`,
      })),
    [sheets]
  );

  const active = data.find((d) => d.value === String(activeSheetId));

  return (
    <Group spacing="sm" noWrap>
      {!compact && (
        <Text size="sm" color="dimmed" style={{ whiteSpace: 'nowrap' }}>
          Sheet:
        </Text>
      )}

      <Select
        searchable
        clearable={false}
        nothingFound="No sheets"
        data={data}
        value={String(activeSheetId)}
        onChange={(val) => onChange?.(val)}
        maxDropdownHeight={260}
        styles={{
          input: { minWidth: 260 },
          dropdown: { minWidth: 320 },
        }}
        itemComponent={({ value, label, ...rest }) => {
          const s = sheets.find(
            (x) => String(x.sheetId ?? x.index) === String(value)
          );
          return (
            <div {...rest} style={{ padding: '8px 10px' }}>
              <Group position="apart" noWrap>
                <Group spacing={6} noWrap>
                  <Badge size="xs" variant="outline">
                    #{s?.index ?? value}
                  </Badge>
                  <Text size="sm" weight={600}>
                    {label}
                  </Text>
                </Group>
                <Text size="xs" color="dimmed">
                  {`${s?.rows ?? '—'} × ${s?.cols ?? '—'}`}
                </Text>
              </Group>
            </div>
          );
        }}
      />

      {active && (
        <Tooltip label={active.description} withArrow>
          <Badge variant="light" color="gray">
            {active.description}
          </Badge>
        </Tooltip>
      )}
    </Group>
  );
}
